import type { LocationQuery, LocationQueryValue } from 'vue-router'

const TRACKING_PARAM = /^(?:utm_|_cb$|gclid$|fbclid$|msclkid$|mc_cid$|mc_eid$)/

function firstValue(value: LocationQueryValue | LocationQueryValue[]): string | null {
  return Array.isArray(value) ? (value[0] ?? null) : value
}

/** The `?…` suffix a listing page's canonical carries; only `page`, past page 1, survives. */
export function resolveCanonicalQuery(query: LocationQuery): string {
  const meaningful = Object.keys(query).filter(key => !TRACKING_PARAM.test(key))

  // A facet view duplicates the unfiltered listing, and its page N holds different
  // products than the base listing's page N — so both collapse onto the clean path.
  if (meaningful.some(key => key !== 'page'))
    return ''

  const page = Number(firstValue(query.page ?? null))

  return Number.isInteger(page) && page > 1 ? `?page=${page}` : ''
}
